import React from "react";
import { Col, Row } from "react-bootstrap";
import SplitNumber from "../../../components/SplitNumber";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { isMobile } from "react-device-detect";

function FactorPaymentListItem(props) {
  return (
    <>
      {isMobile ? (
        <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
          <Col xs="12" xl="4" className=" small-svg">
            <Row className="bg-light rounded-3  p-2 mb-1">
              <Col
                className={props.styleNameClass1}
                style={{
                  backgroundColor: props.bgcolor1,
                }}
              >
                <span className="pe-1">{props.itemIcon}</span>
                {props.FactorItemTitle}
              </Col>

              <Col
                className={props.styleNameClass2}
                style={{ backgroundColor: props.bgcolor2 }}
              >
                {" "}
                {/* {props.isLoading ? (
                  <Skeleton width={100} />
                ) : ( */}
                <span
                  style={{
                    textDecoration: props.isLine ? "line-through" : "",
                  }}
                >
                  {!props.FactorItemCount == "" && (
                    <SplitNumber number={props.FactorItemCount} />
                  )}
                </span>
                {/* )} */}
              </Col>
            </Row>
          </Col>
        </SkeletonTheme>
      ) : (
        <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
          <Col xs="12" className=" small-svg">
            <Row className="  p-2 mb-1">
              <Col
                xs="auto"
                className={props.styleNameClass1}
                style={{
                  backgroundColor: props.bgcolor1,
                }}
              >
                <span className="pe-1">{props.itemIcon}</span>
                {props.FactorItemTitle}
              </Col>
              <Col className="my-auto opacity-10">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col
                xs="auto"
                className={props.styleNameClass2}
                style={{ backgroundColor: props.bgcolor2 }}
              >
                {" "}
                {/* {props.isLoading ? (
                  <Skeleton width={100} />
                ) : ( */}
                <span
                  style={{
                    textDecoration: props.isLine ? "line-through" : "",
                  }}
                >
                  {!props.FactorItemCount == "" && (
                    <SplitNumber number={props.FactorItemCount} />
                  )}
                </span>
                {/* )} */}
              </Col>
            </Row>
          </Col>
        </SkeletonTheme>
      )}
    </>
  );
}

export default FactorPaymentListItem;
